interface Props {
  readonly size?: number;
}

export default function WithdrawIcon(props: Props) {
  const { size = 19 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 0a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19Zm0 4.37L4.93 8.93a.8.8 0 0 0 0 1.14l.08.06a.8.8 0 0 0 1.06-.06L8.7 7.43v6.07a.8.8 0 1 0 1.6 0V7.43l2.63 2.64a.8.8 0 1 0 1.14-1.14L9.5 4.37Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
